import * as React from 'react';
export function Network(
  props: React.HTMLAttributes<SVGSVGElement> & { label: string },
) {
  return (
    <svg
      aria-label={props.label}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_5771_2717)">
        <path
          d="M16.5 9.13397C17.1667 9.51887 17.1667 10.4811 16.5 10.866L4.5 17.7942C3.83333 18.1791 3 17.698 3 16.9282L3 3.0718C3 2.302 3.83333 1.82087 4.5 2.20577L16.5 9.13397Z"
          fill="url(#paint0_linear_5771_2717)"
        />
        <g filter="url(#filter0_bi_5771_2717)">
          <path
            d="M7.5 13.134C6.83333 13.5189 6.83333 14.4811 7.5 14.866L19.5 21.7942C20.1667 22.1791 21 21.698 21 20.9282L21 7.0718C21 6.302 20.1667 5.82087 19.5 6.20577L7.5 13.134Z"
            fill="white"
            fillOpacity="0.5"
          />
          <path
            d="M7.75 14.433L19.75 21.3612C20.0833 21.5537 20.5 21.3131 20.5 20.9282L20.5 7.0718C20.5 6.6869 20.0833 6.44633 19.75 6.63878L7.75 13.567C7.41667 13.7594 7.41667 14.2406 7.75 14.433Z"
            stroke="white"
            strokeOpacity="0.2"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_bi_5771_2717"
          x="5.5"
          y="4.57031"
          width="17"
          height="18.8594"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="0.75" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_5771_2717"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_5771_2717"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_5771_2717"
          />
        </filter>
        <linearGradient
          id="paint0_linear_5771_2717"
          x1="8.83333"
          y1="1.66667"
          x2="8.83333"
          y2="15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBFF32" stopOpacity="0.04" />
          <stop offset="1" stopColor="#FBFF32" />
        </linearGradient>
        <clipPath id="clip0_5771_2717">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
